import { IEnvironment } from './environment.interface';
import { buildAccountEndpoints, buildAuthEndpoints, buildLeadsEndpoints } from './environment.endpoints';
import { defaultManualBilling } from './billing-manual.config';

export const api = {
  base_url: 'https://trieonhr-subscription-dev-amcabyh8f8emgybm.eastasia-01.azurewebsites.net',
  base_api_root: 'https://trieonhr-subscription-dev-amcabyh8f8emgybm.eastasia-01.azurewebsites.net/api/sub',
};

export const environment: IEnvironment = {
  production: false,
  name: 'DEV',
  site_version: '1.0.0',
  api_base_url: api.base_api_root,
  api_token: 'token',
  api_refresh_token: 'refresh_token',
  betaEnabled: true,
  hrisAppUrl: 'http://hris-dev.trieonhr.com',
  mobileApiBaseUrl: 'https://trieonhr-api-dev-h3gzhefkene3fjb5.eastasia-01.azurewebsites.net/api/v1',
  mobileHubUrl: 'https://trieonhr-api-dev-h3gzhefkene3fjb5.eastasia-01.azurewebsites.net/hubs/notification',
  manualBilling: defaultManualBilling,
  auth: buildAuthEndpoints(api.base_api_root),
  plans: { root: `${api.base_api_root}/plans` },
  leads: buildLeadsEndpoints(api.base_api_root),
  account: buildAccountEndpoints(api.base_api_root),
};
